<template>
  <b-modal id="modal-accion"
  size="md"
  hide-footer
  center
  header-class="d-block bg-orange"
>
    <template #modal-header>
      <h5 class="modal-title"><strong>Acción Requerida</strong></h5>
    </template>

    <div class="modal-body pb-0 pr-0">
      <div class="row">
        <div
          class="col-sm-4"
          v-for="(trabajador) in trabajadores"
          :key="trabajador.id"
        >
          <button
            class="btn btn-block px-0"
            :class="selectedOption === trabajador.id ? 'btn-success' : 'bg-gray'"
            @click="selectOption(trabajador.id)"
            style="white-space: normal; word-wrap: break-word; font-size: 11px;"
          >
            {{ trabajador.nombre }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from '@/modules/common/axiosERP';

export default {
  name: 'ModalAccion',
  data() {
    return {
      selectedOption: null,
      paciente_id: null,
      medico_id: null,
      trabajadores: [
        { id: 1, nombre: 'Trabajarlo' },
        /* { id: 2, nombre: 'Trabajar/Compartir' },
        { id: 3, nombre: 'Transferir' }, */
      ],
    };
  },
  methods: {
    async selectOption(id) {
      await axios.put(
        `/clinic/orden_trabajo/${this.paciente_id.orden_trabajo_id}/update_estado`,
      );
      this.selectedOption = id;

      // Cerrar el modal
      this.$bvModal.hide('modal-accion');

      // Navegar a la vista de edición con los datos encriptados
      const query = {
        estado_orden_id: this.encrypt(id),
        medico_id: this.encrypt(this.medico_id),
      };
      // Solo agregar paciente_id si existe
      if (this.paciente_id.paciente_id) {
        query.paciente_id = this.encrypt(this.paciente_id.paciente_id);
      }
      // Si viene de grupal, agregar parámetro
      if (this.paciente_id.grupal) {
        query.grupal = 'true';
      }
      this.$router.push({
        name: 'orden-trabajo-doctor-edit',
        params: {
          id: this.encrypt(this.paciente_id.orden_trabajo_id),
        },
        query,
      });
    },
    show(pacienteId, medicoId) {
      console.log('open modal - paciente:', pacienteId, 'medico:', medicoId);
      this.paciente_id = pacienteId;
      this.medico_id = medicoId;
      this.$bvModal.show('modal-accion');
    },
    encrypt(value) {
      return btoa(value.toString());
    },
  },
};
</script>
